<template>
  <v-app-bar app color="white" flat>
    <v-tabs v-model="tab" background-color="white" light centered center-active>
      <v-tab
        v-for="route of routes"
        :key="route.name"
        :to="{ name: route.link }"
        replace
        v-text="route.name"
        :value="route.name"
        class="text-capitalize"
      >
      </v-tab>
    </v-tabs>
    <v-spacer />
    <v-btn
      v-if="isUserLoggedIn"
      icon
      color="primary"
      @click="logout"
      class="px-3"
    >
      <v-icon>logout</v-icon>
    </v-btn>
    <v-btn
      v-else
      icon
      color="primary"
      @click="login"
      class="px-3"
    >
      <v-icon>account_circle</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name: 'NavBar',
  computed: {
    tab: {
      get() {
        return this.$store.getters['SELECTED_LINK']
      },
      set(route) {
        this.$store.commit('SET_SELECTED_LINK', route)
      }
    },
    isUserLoggedIn() {
      return this.$store.getters['users/AUTH_USER']
    },
    user() {
      return this.$store.getters['users/USER']
    },
    routes() {
      const links = this.$store.getters['LINKS']

      if (!this.isUserLoggedIn) {
        return links.filter((link) => !link.authRequired)
      }

      if (this.isUserLoggedIn && this.user.role !== 'admin') {
        return links.filter((link) => link.name !== 'Admin')
      }

      return this.$store.getters['LINKS']
    }
  },
  methods: {
    async login() {
      this.$emit('onLoginClick')
    },
    async logout() {
      await this.$store.dispatch('users/LOGOUT')
      window.location.reload(false)
    }
  }
}
</script>

<style></style>
